import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BehaviorSubject } from 'rxjs';
import { VtSSOService } from './vt-sso.service'; // Update the path as needed
import { PermissionService } from 'projects/vss-ui/src/public-api'

@Injectable({
  providedIn: 'root'
})
export class VssAuthService {
  private authSubject = new BehaviorSubject<boolean>(this.isAuthenticated());
  // private userKeycloak: any;

  constructor(
    public router: Router,
    private modalService: NzModalService,
    protected readonly keycloakService: KeycloakService,
    private vtSSOService: VtSSOService,
    private permissionService: PermissionService
    ) {
    }

  public getUser() {
    return localStorage.getItem('user');
  }
  public setUser(user: any) {
    localStorage.setItem('user', user);
  }

  public isAuthenticated(): boolean {
    if (localStorage.getItem('access_token') != null){
      return true;
    }
    return false;
  }
  public setToken(token: any) {
    localStorage.setItem('access_token', token);
  }
  public getToken(isUsingKeycloak: boolean) {
    if(!isUsingKeycloak)
      return localStorage.getItem('access_token');
    let _token = null;
    this.keycloakService.getToken().then((value)=>{
      _token = value;
    });
    return _token;
  }
  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('ticket');
    localStorage.removeItem('menuItems');
    localStorage.removeItem('roles');
    localStorage.removeItem('userLogin');
    this.permissionService.menuObs.next([]);

    this.authSubject.next(false);
    this.modalService.closeAll();

    const SSOAcc = localStorage.getItem('sso');

    if (SSOAcc) {
      localStorage.removeItem('sso');
      this.vtSSOService.redirectToLogout();
      return
    }
    this.router.navigate(['/auth/login']);
  }

}
